import { Icon } from '@zambezi/sdk/icons';
import React from 'react';
import './Badge.scss';

interface BadgeProps extends React.HTMLProps<HTMLSpanElement> {
  children: React.ReactNode | React.ReactNode[];
  icon?: string;
}

const Badge = ({ children, icon, ...rest }: BadgeProps) => {
  return (
    <span className="mss-badge" {...rest}>
      {icon && <Icon name={icon} size="xsmall" title="" />}
      <span>{children}</span>
    </span>
  );
};

export default Badge;
